import type { FC } from "react";
import type { IconBaseProps } from "react-icons";
import {
  FiSearch as RiSearch,
  FiShoppingBag as RiShoppingBag,
  FiMapPin as RiMapPin,
  FiMenu as RiMenu,
  FiChevronDown as RiChevronDown,
  FiX as RiX,
  FiMail as RiMail,
  FiCheck as RiCheck,
  FiPlus as RiPlus,
  FiMinus as RiMinus,
} from "react-icons/fi";
import {
  FaInstagram as RiInstagram,
  FaFacebookF as RiFacebookF,
  FaViber as RiViber,
} from "react-icons/fa";

/**
 * react-icons' `IconType` is typed as `(props) => ReactNode`, which this
 * project's older `@types/react` (18.0.38) rejects as a JSX component (it
 * requires `ReactElement | null`). Re-export each icon cast to the project's
 * `FC` so they can be used as JSX without bumping the React type packages.
 */
type IconFC = FC<IconBaseProps>;

export const FiSearch = RiSearch as IconFC;
export const FiShoppingBag = RiShoppingBag as IconFC;
export const FiMapPin = RiMapPin as IconFC;
export const FiMenu = RiMenu as IconFC;
export const FiChevronDown = RiChevronDown as IconFC;
export const FiX = RiX as IconFC;
export const FiMail = RiMail as IconFC;
export const FiCheck = RiCheck as IconFC;
export const FiPlus = RiPlus as IconFC;
export const FiMinus = RiMinus as IconFC;
export const FaInstagram = RiInstagram as IconFC;
export const FaFacebookF = RiFacebookF as IconFC;
export const FaViber = RiViber as IconFC;
